/**
 * 스와이프 제스처를 처리하기 위한 커스텀 훅.
 *
 * @param {Object} options - 제스처 훅의 옵션.
 * @param {Function} [options.onSwipeLeft] - 왼쪽으로 스와이프할 때 호출되는 콜백 함수.
 * @param {Function} [options.onSwipeRight] - 오른쪽으로 스와이프할 때 호출되는 콜백 함수.
 * @param {number} [options.SWIPE_THRESHOLD=100] - 스와이프를 감지하기 위한 임계값(픽셀 단위). 기본값은 100.
 * @returns {Object} - 제스처 핸들러를 요소에 연결하기 위한 메서드 집합.
 */
export function useGesture({
  onSwipeLeft,
  onSwipeRight,
  SWIPE_THRESHOLD = 100, // 스와이프를 감지하기 위한 기본 임계값
} = {}) {
  /** 드래그/스와이프 시작 X좌표 */
  const startX = ref(0);
  /** 드래그/스와이프 동작 상태 */
  const isDragging = ref(false);
  /** 드래그/스와이프 X좌표 이동 거리 */
  const translateX = ref(0);

  /** 감지된 스와이프 방향 ('left' | 'right' | null) */
  const swipeDirection = ref(null);

  const handleStart = (event) => {
    const point = event.touches ? event.touches[0] : event;
    startX.value = point.clientX;
    isDragging.value = true;
    swipeDirection.value = null; // 초기화
  };

  const handleMove = (event) => {
    if (!isDragging.value) return;

    const point = event.touches ? event.touches[0] : event;
    const deltaX = point.clientX - startX.value;

    // 임계값을 넘으면 방향만 저장하고, 실제 동작은 handleEnd에서 수행
    if (Math.abs(deltaX) > SWIPE_THRESHOLD) {
      if (deltaX > 0) {
        swipeDirection.value = 'right';
      } else {
        swipeDirection.value = 'left';
      }
    } else {
      swipeDirection.value = null;
    }

    translateX.value = deltaX;
  };

  const handleEnd = () => {
    if (isDragging.value) {
      // 드래그가 끝나는 시점에 방향이 정해져 있다면 콜백 실행
      if (swipeDirection.value === 'right') {
        onSwipeRight?.();
      } else if (swipeDirection.value === 'left') {
        onSwipeLeft?.();
      }

      isDragging.value = false;
      swipeDirection.value = null;
      translateX.value = 0;
    }
  };

  return {
    handleStart,
    handleMove,
    handleEnd,
  };
}
